require('./style.less');

var Marionette = require('marionette'),
    Backbone = require('backbone');

/* Really the Center Content */
module.exports = Marionette.ItemView.extend({
    template: require('./template'),
    onRender: Backbone.View.prototype.unwrap
});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/viewModes/noPagesOverlay/view.js
 ** module id = 480
 ** module chunks = 0
 **/